// Premium bottom-center legal footer for authentication pages.
// Styling reference: Stripe / Linear / Vercel auth pages.
//
//   [Privacy Policy · Terms & Conditions · Cookie Policy · Cookie Preferences]
//
// - Absolute-positioned at the very bottom center of the viewport.
// - 12px muted gray text, smooth hover to foreground.
// - `Cookie Preferences` opens the consent manager modal instead of navigating.
// - Responsive: on narrow screens the links wrap; dividers stay balanced.

import { Link } from "react-router-dom";
import { useConsent } from "./cookieConsent";

const LINKS = [
  { key: "privacy",  to: "/privacy",  label: "Privacy Policy" },
  { key: "terms",    to: "/terms",    label: "Terms & Conditions" },
  { key: "cookies",  to: "/cookies",  label: "Cookie Policy" },
];

export default function AuthLegalFooter() {
  const { openManager } = useConsent();
  return (
    <footer
      className="w-full py-6 px-4 flex items-center justify-center border-t border-border/50 bg-transparent"
      data-testid="auth-legal-footer"
      aria-label="Legal links"
    >
      <nav className="flex flex-wrap items-center justify-center gap-x-4 sm:gap-x-6 gap-y-2 text-[12px] leading-none">
        {LINKS.map((l, i) => (
          <span key={l.key} className="flex items-center gap-x-4 sm:gap-x-6">
            <Link
              to={l.to}
              className="text-gray-500 hover:text-white transition-colors duration-200"
              data-testid={`auth-legal-${l.key}`}
            >
              {l.label}
            </Link>
            {i < LINKS.length && (
              <span aria-hidden className="text-gray-700 select-none">•</span>
            )}
          </span>
        ))}
        <button
          type="button"
          onClick={openManager}
          className="text-gray-500 hover:text-white transition-colors duration-200"
          data-testid="auth-legal-cookie-prefs"
        >
          Cookie Preferences
        </button>
      </nav>
    </footer>
  );
}
